/**
 * Mensagens visíveis a usuários finais: nunca IP, URL interna, HTTP cru ou stack.
 * Doc: backend-delivai/docs/frontend/user-facing-errors.md
 */

export function isTechnicalUserFacingMessage(
  message: string | null | undefined
): boolean {
  const m = (message || "").trim();
  if (!m) return false;
  return (
    /\bhttps?:\/\//i.test(m) ||
    /\b\d{1,3}(?:\.\d{1,3}){3}\b/.test(m) ||
    /\b(400|401|403|404|500|502|503|504)\b/.test(m) ||
    /^[a-z][a-z0-9]*(?:_[a-z0-9]+)+$/i.test(m) || // códigos machine: mercadopago_api_error
    /bad request|bad gateway|gateway timeout|gateway incorreto|internal server error|webclient|sendtext|evolution|easypanel|stack trace|exception|localhost|\bunauthorized\b|\bforbidden\b/i.test(
      m
    ) ||
    /java heap|heap space|outofmemory|out of memory|java\.lang\./i.test(m) ||
    /ERROR:\s*column|does not exist|Position:\s*\d+|psqlexception/i.test(m) ||
    /<!doctype\s+html|<html[\s>]|service not reachable|not reachable/i.test(m)
  );
}

/** Substitui mensagem técnica por fallback seguro para toast/inline. */
export function safeUserFacingMessage(
  message: string | null | undefined,
  fallback: string
): string {
  const m = (message || "").trim();
  if (!m || isTechnicalUserFacingMessage(m)) return fallback;
  return m;
}
